import { Component, inject } from '@angular/core';
import { UwIcon } from '../../ui/icon/uw-icon';
import { UwBadge } from '../../ui/badge/uw-badge';
import { EvidenceStore } from '../../../core/stores/evidence.store';
import { UwMoneyPipe } from '../../pipes/format.pipes';

@Component({
  selector: 'uw-evidence-source',
  standalone: true,
  imports: [UwIcon, UwBadge, UwMoneyPipe],
  template: `
    @if (evidence.activeSource(); as source) {
      <div class="overflow-hidden rounded-lg border border-line bg-surface-elevated">
        <div class="flex items-start gap-2 border-b border-line bg-surface-sunken/60 px-3 py-2.5">
          <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-ai-soft text-ai">
            <uw-icon name="file-search" [size]="14" />
          </span>
          <div class="min-w-0 flex-1">
            <p class="truncate text-[12.5px] font-semibold text-primary">{{ source.documentName }}</p>
            <p class="text-[10.5px] text-text-muted">{{ source.page }} · {{ source.provider }}</p>
          </div>
          <button
            class="rounded p-0.5 text-text-muted transition-colors hover:text-primary"
            (click)="evidence.closeSource()"
            aria-label="Close source detail"
          >
            <uw-icon name="x" [size]="14" />
          </button>
        </div>

        <div class="space-y-3 px-3 py-3">
          @if (source.claimType || source.policyNumber || source.status || source.incurred) {
            <div class="flex flex-wrap gap-1.5">
              @if (source.policyNumber) {
                <uw-badge tone="neutral" subtle>{{ source.policyNumber }}</uw-badge>
              }
              @if (source.claimType) {
                <uw-badge tone="info" subtle>{{ source.claimType }}</uw-badge>
              }
              @if (source.status) {
                <uw-badge [tone]="source.status === 'Closed' ? 'success' : 'warning'" subtle>{{ source.status }}</uw-badge>
              }
              @if (source.incurred !== undefined) {
                <uw-badge tone="danger" subtle>{{ source.incurred | uwMoney }} incurred</uw-badge>
              }
            </div>
          }

          <p class="rounded-md bg-surface-sunken px-2.5 py-2 font-mono text-[11px] leading-relaxed text-secondary">
            {{ source.snippet }}
          </p>

          <div class="flex items-center gap-1.5 text-[10.5px] text-text-muted">
            <uw-icon name="calendar" [size]="11" />
            {{ source.date }} · Provider: {{ source.provider }}
          </div>
        </div>
      </div>
    }
  `,
})
export class UwEvidenceSource {
  protected readonly evidence = inject(EvidenceStore);
}
